/*
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * External dependencies
 */
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Text, THEME_CONSTANTS } from '@web-stories-wp/design-system';

const StyledText = styled(Text)`
  color: inherit;
  white-space: nowrap;
  text-overflow: ' ';
  overflow: hidden;
  max-width: 100%;
  ${({ isHidden }) =>
    isHidden &&
    css`
      opacity: 0.3;
    `};
`;

export function LayerText({ children, ...rest }) {
  return (
    <StyledText
      forwardedAs="span"
      size={THEME_CONSTANTS.TYPOGRAPHY.PRESET_SIZES.MEDIUM}
      {...rest}
    >
      {children}
    </StyledText>
  );
}
LayerText.propTypes = { children: PropTypes.node };
